export default {
  identify: jest.fn(),
  login: jest.fn(),
  impersonate: jest.fn(),
  autologin: jest.fn(),
  magicLink: jest.fn(),
  socialLogin: jest.fn(),
  validateEmail: jest.fn(),
  validatePhone: jest.fn(),
  createAccount: jest.fn(),
  updatePhantomAccount: jest.fn(),
  logout: jest.fn(),
  retrieveProfile: jest.fn(),
  alerts: jest.fn(),
  markAlertAsViewed: jest.fn(),
  updateProfile: jest.fn(),
  updateProfileProp: jest.fn(),
  updateAvatar: jest.fn(),
  updatePassword: jest.fn(),
  forgotPassword: jest.fn(),
  forgotPasswordHibo: jest.fn(),
  forgotPasswordTokenCheck: jest.fn(),
  forgotPasswordReset: jest.fn(),
  setLoginModalVisibility: jest.fn(),
  loading: jest.fn(),
  isAuthenticated: jest.fn(),
  userAvatar: jest.fn(),
  userFirstName: jest.fn(),
};
